import React, { useEffect, useState } from "react";
import axios from "../axios";
import { NotificationManager } from "react-notifications";
import Switch from "react-switch";
import PrimaryCheckbox from "./Common/PrimaryCheckbox";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import moment from "moment";

// import { render } from '@testing-library/react';

const Symptoms = (props) => {
  const status = {
    backgroundColor: "#f85353",
    boxShadow: "0 0 7px 0 #f8535380",
  };

  console.log(props.record.symptoms);

  let symptomsObject = props.record.symptoms;

  if (localStorage.plan == "covid" && localStorage.Tb == "tb") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            //Wrong keys
            // key !== "family_suffering_with_tb_asthma_others" &&
            // key !== "headache" &&
            // key !== "frequent_night_awakening" &&
            // key !== "symptoms_effect_daily_life" &&
            // key !== "fever_with_chills" &&
            // key !== "diarrhoea_vomiting" &&
            // key !== "running_nose_sneezing" &&
            // key !== "earlier_breathing_problems" &&
            // key !== "muscle_pain" &&
            // key !== "diminished_sense_of_smell" &&
            key !== "loss_of_appetit" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            key !== "exposure_to_any_kind_of_smoke" &&
            key !== "family_history_of_asthma" &&
            key !== "active_asthma_past" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "sore_throat"
                    ? "Sore throat"
                    : key && key === "running_nose"
                    ? "Running nose / Sneezing"
                    : key && key === "loss_of_smell_taste"
                    ? "Loss or diminished sense of smell / Taste"
                    : key && key === "body_pains"
                    ? "Body pain / Headache"
                    : key && key === "diarrhoea"
                    ? "Diarrhoea / Vomiting"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "cough_with_sputum_and_blood"
                    ? "Cough with sputum and blood at times"
                    : key && key === "sweat_heavy_at_night"
                    ? "Night sweats / Chills"
                    : key && key === "loss_of_appetite"
                    ? "Loss of appetite"
                    : key && key === "weight_loss"
                    ? "Weight loss"
                    : key && key === "evening_rise_in_temperature"
                    ? "Evening rise in temperature"
                    : key && key === "contact_with_covid_positive"
                    ? "Contact with covid positive"
                    : key && key === "previously_infected_with_covid"
                    ? "Previously infected with covid"
                    : key && key === "known_person_having_active_tb"
                    ? "Family / Known person having TB"
                    : key && key === "active_tb_past"
                    ? "Active TB in past"
                    : key && key === "family_suffering_with_tb_asthma_others"
                    ? "Family suffering with TB Asthma or others"
                    : key && key === "headache"
                    ? "Headache"
                    : key && key === "frequent_night_awakening"
                    ? "Frequent night awakening"
                    : key && key === "symptoms_effect_daily_life"
                    ? "Symptoms effect daily life"
                    : key && key === "fever_with_chills"
                    ? "Fever with chills"
                    : key && key === "diarrhoea_vomiting"
                    ? "Diarrhoea/Vomiting"
                    : key && key === "running_nose_sneezing"
                    ? "Running Nose / Sneezing"
                    : key && key === "earlier_breathing_problems"
                    ? "Earlier breathing problems"
                    : key && key === "muscle_pain"
                    ? "Muscle Pain"
                    : key && key === "diminished_sense_of_smell"
                    ? "Diminished sense of smell"
                    : key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  } else if (localStorage.plan == "covid") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            //Wrong keys
            // key !== "family_suffering_with_tb_asthma_others" &&
            // key !== "headache" &&
            // key !== "frequent_night_awakening" &&
            // key !== "symptoms_effect_daily_life" &&
            // key !== "fever_with_chills" &&
            // key !== "diarrhoea_vomiting" &&
            // key !== "running_nose_sneezing" &&
            // key !== "earlier_breathing_problems" &&
            // key !== "muscle_pain" &&
            // key !== "diminished_sense_of_smell" &&
            key !== "loss_of_appetit" &&
            //Exluded Keys/symptoms
            key !== "cough_with_sputum_and_blood" &&
            key !== "sweat_heavy_at_night" &&
            key !== "loss_of_appetite" &&
            key !== "weight_loss" &&
            key !== "evening_rise_in_temperature" &&
            key !== "known_person_having_active_tb" &&
            key !== "active_tb_past" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            key !== "exposure_to_any_kind_of_smoke" &&
            key !== "family_history_of_asthma" &&
            key !== "active_asthma_past" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "sore_throat"
                    ? "Sore throat"
                    : key && key === "running_nose"
                    ? "Running nose / Sneezing"
                    : key && key === "loss_of_smell_taste"
                    ? "Loss or diminished sense of smell / Taste"
                    : key && key === "body_pains"
                    ? "Body pain / Headache"
                    : key && key === "diarrhoea"
                    ? "Diarrhoea / Vomiting"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "contact_with_covid_positive"
                    ? "Contact with covid positive"
                    : key && key === "previously_infected_with_covid"
                    ? "Previously infected with covid"
                    : // : key && key === "cough_with_sputum_and_blood"
                    // ? "Cough with sputum and blood at some times"
                    // : key && key === "sweat_heavy_at_night"
                    // ? "Night sweats / Chills"
                    // : key && key === "loss_of_appetite"
                    // ? "Loss of appetite"
                    // : key && key === "weight_loss"
                    // ? "Weight loss"
                    // : key && key === "evening_rise_in_temperature"
                    // ? "Evening rise in temperature"
                    // : key && key === "known_person_having_active_tb"
                    // ? "Family / Known person having TB"
                    // : key && key === "active_tb_past"
                    // ? "Active TB in past"
                    // : key && key === "family_suffering_with_tb_asthma_others"
                    // ? "Family suffering with TB Asthma or others"
                    key && key === "headache"
                    ? "Headache"
                    : key && key === "frequent_night_awakening"
                    ? "Frequent night awakening"
                    : // : key && key === "symptoms_effect_daily_life"
                    // ? "Symptoms effect daily life"
                    // : key && key === "fever_with_chills"
                    // ? "Fever with chills"
                    // : key && key === "diarrhoea_vomiting"
                    // ? "Diarrhoea/Vomiting"
                    // : key && key === "running_nose_sneezing"
                    // ? "Running Nose/Sneezing"
                    // : key && key === "earlier_breathing_problems"
                    // ? "Earlier breathing problems"
                    key && key === "muscle_pain"
                    ? "Muscle pain"
                    : // : key && key === "diminished_sense_of_smell"
                      // ? "Diminished sense of smell"
                      key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.Tb === "tb" && localStorage.asthma === "asthma" && localStorage.copd === "copd") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "cough_with_sputum_and_blood"
                    ? "Cough with sputum and blood at times"
                    : key && key === "sweat_heavy_at_night"
                    ? "Night sweats / Chills"
                    : key && key === "loss_of_appetite"
                    ? "Loss of appetite"
                    : key && key === "weight_loss"
                    ? "Weight loss"
                    : key && key === "evening_rise_in_temperature"
                    ? "Evening rise in temperature"
                    : key && key === "known_person_having_active_tb"
                    ? "Family / Known person having TB"
                    : key && key === "active_tb_past"
                    ? "Active TB in past"
                    : key && key === "family_history_of_asthma"
                    ? "Family history of asthma"
                    : key && key === "active_asthma_past"
                    ? "Active asthma in past"
                    : key && key === "exposure_to_any_kind_of_smoke"
                    ? "Exposed to any kind of smoke"
                    : key && key === "smoking"
                    ? "Smoking"
                    : key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.Tb === "tb" && localStorage.asthma === "asthma") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            key !== "smoking" &&
            key !== "exposure_to_any_kind_of_smoke" &&
            // key !== "family_history_of_asthma" &&
            // key !== "active_asthma_past" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "cough_with_sputum_and_blood"
                    ? "Cough with sputum and blood at times"
                    : key && key === "sweat_heavy_at_night"
                    ? "Night sweats / Chills"
                    : key && key === "loss_of_appetite"
                    ? "Loss of appetite"
                    : key && key === "weight_loss"
                    ? "Weight loss"
                    : key && key === "evening_rise_in_temperature"
                    ? "Evening rise in temperature"
                    : key && key === "known_person_having_active_tb"
                    ? "Family / Known person having TB"
                    : key && key === "active_tb_past"
                    ? "Active TB in past"
                    : key && key === "family_history_of_asthma"
                    ? "Family history of asthma"
                    : key && key === "active_asthma_past"
                    ? "Active asthma in past"
                    : key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.Tb === "tb" && localStorage.copd === "copd") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            key !== "family_history_of_asthma" &&
            key !== "active_asthma_past" &&
            // key !== "smoking" &&
            // key !== "exposure_to_any_kind_of_smoke" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "cough_with_sputum_and_blood"
                    ? "Cough with sputum and blood at times"
                    : key && key === "sweat_heavy_at_night"
                    ? "Night sweats / Chills"
                    : key && key === "loss_of_appetite"
                    ? "Loss of appetite"
                    : key && key === "weight_loss"
                    ? "Weight loss"
                    : key && key === "evening_rise_in_temperature"
                    ? "Evening rise in temperature"
                    : key && key === "known_person_having_active_tb"
                    ? "Family / Known person having TB"
                    : key && key === "active_tb_past"
                    ? "Active TB in past"
                    : key && key === "exposure_to_any_kind_of_smoke"
                    ? "Exposed to any kind of smoke"
                    : key && key === "smoking"
                    ? "Smoking"
                    : key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.Tb == "tb") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            //Wrong keys
            // key !== "family_suffering_with_tb_asthma_others" &&
            // // key !== "headache" &&
            // key !== "frequent_night_awakening" &&
            // key !== "symptoms_effect_daily_life" &&
            // key !== "fever_with_chills" &&
            // key !== "diarrhoea_vomiting" &&
            // key !== "running_nose_sneezing" &&
            // key !== "earlier_breathing_problems" &&
            // // key !== "muscle_pain" &&
            // key !== "diminished_sense_of_smell" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            // key !== "exposure_to_any_kind_of_smoke" &&
            // key !== "family_history_of_asthma" &&
            // key !== "active_asthma_past" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "fatigue"
                    ? "Fatigue / Tiredness"
                    : key && key === "cough_with_sputum_and_blood"
                    ? "Cough with sputum and blood at times"
                    : key && key === "sweat_heavy_at_night"
                    ? "Night sweats / Chills"
                    : key && key === "loss_of_appetite"
                    ? "Loss of appetite"
                    : key && key === "weight_loss"
                    ? "Weight loss"
                    : key && key === "evening_rise_in_temperature"
                    ? "Evening rise in temperature"
                    : key && key === "known_person_having_active_tb"
                    ? "Family / Known person having TB"
                    : key && key === "active_tb_past"
                    ? "Active TB in past"
                    : // : key && key === "sore_throat"
                    // ? "Sore throat"
                    // : key && key === "running_nose"
                    // ? "Running nose/Sneezing"
                    // : key && key === "loss_of_smell_taste"
                    // ? "Loss or diminished sense of smell / Taste"
                    // : key && key === "body_pains"
                    // ? "Body pain / Headache"
                    // : key && key === "diarrhoea"
                    // ? "Diarrhoea / Vomiting"
                    // : key && key === "contact_with_covid_positive"
                    // ? "Contact with covid positive"
                    // : key && key === "previously_infected_with_covid"
                    // ? "Previously infected with covid"
                    // : key && key === "family_suffering_with_tb_asthma_others"
                    // ? "Family suffering with TB Asthma or others"
                    key && key === "headache"
                    ? "Headache"
                    : key && key === "frequent_night_awakening"
                    ? "Frequent night awakening"
                    : // : key && key === "symptoms_effect_daily_life"
                    // ? "Symptoms effect daily life"
                    // : key && key === "fever_with_chills"
                    // ? "Fever with chills"
                    // : key && key === "diarrhoea_vomiting"
                    // ? "Diarrhoea/Vomiting"
                    // : key && key === "running_nose_sneezing"
                    // ? "Running Nose/Sneezing"
                    // : key && key === "earlier_breathing_problems"
                    // ? "Earlier breathing problems"
                    key && key === "muscle_pain"
                    ? "Muscle pain"
                    : // : key && key === "diminished_sense_of_smell"
                      // ? "Diminished sense of smell"
                      key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.asthma === "asthma" && localStorage.copd === "copd") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            // key !== "exposure_to_any_kind_of_smoke" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    // : key && key === "fever"
                    // ? "Fever"
                    : key && key === "family_history_of_asthma"
                    ? "Family history of asthma"
                    : key && key === "active_asthma_past"
                    ? "Active asthma in past"
                    : key && key === "exposure_to_any_kind_of_smoke"
                    ? "Exposed to any kind of smoke"
                    : key && key === "smoking"
                    ? "Smoking"
                    :
                    key}
                </p>
                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.asthma === "asthma") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            // key !== "exposure_to_any_kind_of_smoke" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "family_history_of_asthma"
                    ? "Family history of asthma"
                    : key && key === "active_asthma_past"
                    ? "Active asthma in past"
                    :
                    key}
                </p>
                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else if (localStorage.copd === "copd") {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //Exlcluded keys/symptoms
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            // key !== "smoking" &&
            // key !== "exposure_to_any_kind_of_smoke" &&
            // key !== "family_history_of_asthma" &&
            // key !== "active_asthma_past" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {
                    key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : key && key === "fever"
                    ? "Fever"
                    : key && key === "exposure_to_any_kind_of_smoke"
                    ? "Exposed to any kind of smoke"
                    : key && key === "smoking"
                    ? "Smoking"
                    : key}
                </p>
                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
  else {
    return (
      <div className="patient__report__table">
        {Object.keys(symptomsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            //Wrong keys
            // key !== "family_suffering_with_tb_asthma_others" &&
            // key !== "headache" &&
            // key !== "frequent_night_awakening" &&
            // key !== "symptoms_effect_daily_life" &&
            // key !== "fever_with_chills" &&
            // key !== "diarrhoea_vomiting" &&
            // key !== "running_nose_sneezing" &&
            // key !== "earlier_breathing_problems" &&
            // key !== "muscle_pain" &&
            // key !== "diminished_sense_of_smell" &&
            key !== "loss_of_appetit" &&
            //Excluded keys/symptoms
            key !== "fever" &&
            key !== "sore_throat" &&
            key !== "running_nose" &&
            key !== "loss_of_smell_taste" &&
            key !== "body_pains" &&
            key !== "diarrhoea" &&
            key !== "fatigue" &&
            key !== "cough_with_sputum_and_blood" &&
            key !== "sweat_heavy_at_night" &&
            key !== "loss_of_appetite" &&
            key !== "weight_loss" &&
            key !== "evening_rise_in_temperature" &&
            key !== "contact_with_covid_positive" &&
            key !== "previously_infected_with_covid" &&
            key !== "known_person_having_active_tb" &&
            key !== "active_tb_past" &&
            //Medical Conditions
            key !== "heart_disease" &&
            key !== "lung_disease" &&
            key !== "diabetes" &&
            key !== "kidney_problem" &&
            key !== "high_blood_pressure" &&
            key !== "major_operations" &&
            key !== "stroke" &&
            key !== "weak_immune_system" &&
            key !== "pregnancy" &&
            key !== "smoking" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "frequent_cough"
                    ? "Frequent cough"
                    : key && key === "cough_at_night"
                    ? "Cough during night"
                    : key && key === "sputum"
                    ? "Mucus / Sputum"
                    : key && key === "pain_in_chest"
                    ? "Pain in chest"
                    : key && key === "wheezing"
                    ? "Sound in chest while breathing"
                    : key && key === "shortness_of_breath"
                    ? "Difficulty in breathing"
                    : // : key && key === "fever"
                    // ? "Fever"
                    // : key && key === "sore_throat"
                    // ? "Sore throat"
                    // : key && key === "running_nose"
                    // ? "Running nose/Sneezing"
                    // : key && key === "loss_of_smell_taste"
                    // ? "Loss or diminished sense of smell / Taste"
                    // : key && key === "body_pains"
                    // ? "Body pain / Headache"
                    // : key && key === "diarrhoea"
                    // ? "Diarrhoea / Vomiting"
                    // : key && key === "fatigue"
                    // ? "Fatigue / Tiredness"
                    // : key && key === "cough_with_sputum_and_blood"
                    // ? "Cough with sputum and blood at some times"
                    // : key && key === "sweat_heavy_at_night"
                    // ? "Night sweats / Chills"
                    // : key && key === "loss_of_appetite"
                    // ? "Loss of appetite"
                    // : key && key === "weight_loss"
                    // ? "Weight loss"
                    // : key && key === "evening_rise_in_temperature"
                    // ? "Evening rise in temperature"
                    // : key && key === "contact_with_covid_positive"
                    // ? "Contact with covid positive"
                    // : key && key === "previously_infected_with_covid"
                    // ? "Previously infected with covid"
                    // : key && key === "known_person_having_active_tb"
                    // ? "Family / Known person having TB"
                    // : key && key === "active_tb_past"
                    // ? "Active TB in past"

                    // : key && key === "family_suffering_with_tb_asthma_others"
                    // ? "Family suffering with TB Asthma or others"
                    key && key === "headache"
                    ? "Headache"
                    : // : key && key === "frequent_night_awakening"
                    // ? "Frequent night awakening"
                    // : key && key === "symptoms_effect_daily_life"
                    // ? "Symptoms effect daily life"
                    // : key && key === "fever_with_chills"
                    // ? "Fever with chills"
                    // : key && key === "diarrhoea_vomiting"
                    // ? "Diarrhoea/Vomiting"
                    // : key && key === "running_nose_sneezing"
                    // ? "Running Nose/Sneezing"
                    // : key && key === "earlier_breathing_problems"
                    // ? "Earlier breathing problems"
                    key && key === "muscle_pain"
                    ? "Muscle pain"
                    : // : key && key === "diminished_sense_of_smell"
                      // ? "Diminished sense of smell"
                      key}
                </p>

                <div
                  className="patient__report__status"
                  style={symptomsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  }
};

const MedicalConditions = (props) => {
  const status = {
    backgroundColor: "#f85353",
    boxShadow: "0 0 7px 0 #f8535380",
  };

  console.log(props.record.medical_conditions);

  let medicalConditions = props.record.medical_conditions
  let symptomConditions = props.record.symptoms
  // let conditionsObject = medicalConditions !== null ? medicalConditions : symptomConditions;
  let conditionsObject ;

  if (medicalConditions && typeof medicalConditions === 'object') {
    conditionsObject = medicalConditions;
  } else if (symptomConditions && typeof symptomConditions === 'object') {
    conditionsObject = symptomConditions;
  } else {
    conditionsObject = null;
  }
  
  // let conditionsObject = props.record.medical_conditions;

  if (localStorage.plan == "covid") {
    return (
      <div className="patient__report__table">
        {Object.keys(conditionsObject).map(
          (key, index) =>
            key !== "blood_pressure" &&
            key !== "oxygen_saturation" &&
            key !== "pulse_rate" &&
            key !== "respiratory_rate" &&
            key !== "temperature_F" &&
            key !== "loss_of_appetit" &&
            //symptoms
            key !== "cough_at_night" &&
            key !== "sputum" &&
            key !== "fatigue" &&
            key !== "headache" &&
            key !== "wheezing" &&
            key !== "family_suffering_with_tb_asthma_others" &&
            key !== "frequent_night_awakening" &&
            key !== "sore_throat" &&
            key !== "weight_loss" &&
            key !== "pain_in_chest" &&
            key !== "sweat_heavy_at_night" &&
            key !== "loss_of_appetite" &&
            key !== "frequent_cough" &&
            key !== "shortness_of_breath" &&
            key !== "symptoms_effect_daily_life" &&
            key !== "fever_with_chills" &&
            key !== "loss_of_smell_taste" &&
            key !== "diarrhoea_vomiting" &&
            key !== "running_nose_sneezing" &&
            key !== "body_pains" &&
            key !== "fever" &&
            key !== "earlier_breathing_problems" &&
            key !== "muscle_pain" &&
            key !== "diarrhoea" &&
            key !== "contact_with_covid_positive" &&
            key !== "running_nose" &&
            key !== "diminished_sense_of_smell" &&
            key !== "known_person_having_active_tb" &&
            key !== "active_tb_past" &&
            key !== "cough_with_sputum_and_blood" &&
            key !== "evening_rise_in_temperature" &&
            key !== "previously_infected_with_covid" &&
            key.indexOf("duration") === -1 && (
              <div className="patient__report__row" key={index}>
                <p className="patient__report__label">
                  {console.log("key", key, index)}
                  {key === "smoking"
                    ? "Smoking"
                    : key && key === "lung_disease"
                    ? "Lung disease"
                    : key && key === "heart_disease"
                    ? "Heart disease"
                    : key && key === "diabetes"
                    ? "Diabetes"
                    : key && key === "kidney_problem"
                    ? "Kidney problem"
                    : key && key === "high_blood_pressure"
                    ? "High blood pressure"
                    : key && key === "major_operations"
                    ? "Major operation like organ transplant"
                    : key && key === "stroke"
                    ? "Stroke"
                    : key && key === "weak_immune_system"
                    ? "Weak immune system"
                    : key && key === "pregnancy"
                    ? "Pregnancy"
                    : key}
                </p>
                <div
                  className="patient__report__status"
                  style={conditionsObject[key] === 1 ? status : {}}
                ></div>
              </div>
            )
        )}
      </div>
    );
  } else {
    return <><p>No Medical Conditions Found</p></>;
  }
};

const Indications = (props) => { 
  let lhiScore;
  let tbText;
  let covidText;
  let asthmaText
  let copdText;

  if(localStorage.lhi !== "false"){
    const lhiRisk = props.record.cough_risk_score;
    if (lhiRisk >= 1 && lhiRisk <= 3) {
      lhiScore = <p className="_text_risk">Low</p>
    } else if (lhiRisk >= 4 && lhiRisk <= 6) {
      lhiScore = <p className="_text_risk">Medium</p>
    } else if (lhiRisk >= 7 && lhiRisk <= 10) {
      lhiScore = <p className="_text_risk">High</p>
    }
  }

  if (localStorage.Tb === "tb") {
    console.log("tb");
    const  tbRisk  = props.record.tb_RiskScore;
      if (tbRisk >= 1 && tbRisk <= 3) {
        tbText = <p className="_text_risk">Low</p>
      } else if (tbRisk >= 4 && tbRisk <= 6) {
        tbText = <p className="_text_risk">Medium</p>
      } else if (tbRisk >= 7 && tbRisk <= 10) {
        tbText = <p className="_text_risk">High</p>
      }
  }

    if (localStorage.plan === "covid") {
      const covidRisk  = props.record.covid_risk_score;
        if (covidRisk >= 1 && covidRisk <= 3) {
          covidText = <p className="_text_risk">Low</p>
        } else if (covidRisk >= 4 && covidRisk <= 6) {
          covidText = <p className="_text_risk">Medium</p>
        } else if (covidRisk >= 7 && covidRisk <= 10) {
          covidText = <p className="_text_risk">High</p>
        }
    }

    if (localStorage.asthma === "asthma") {
      const asthmaRisk  = props.record.asthma_risk_score;
        if (asthmaRisk >= 1 && asthmaRisk <= 3) {
          asthmaText = <p className="_text_risk">Low</p>
        } else if (asthmaRisk >= 4 && asthmaRisk <= 6) {
          asthmaText = <p className="_text_risk">Medium</p>
        } else if (asthmaRisk >= 7 && asthmaRisk <= 10) {
          asthmaText = <p className="_text_risk">High</p>
        }
    }
  
    if (localStorage.copd === "copd") {
      const copdRisk = props.record.COPD_risk_score;
        if (copdRisk >= 1 && copdRisk <= 3) {
          copdText = <p className="_text_risk">Low</p>
        } else if (copdRisk >= 4 && copdRisk <= 6) {
          copdText = <p className="_text_risk">Medium</p>
        } else if (copdRisk >= 7 && copdRisk <= 10) {
          copdText = <p className="_text_risk">High</p>
        }
    }

    console.log("Normal",props.record.risk);
    let underlyingRiskText;
    if(props.record.risk == "Yes"){
      underlyingRiskText = "Abnormal"
    }else if (props.record.risk == "No"){
      underlyingRiskText = "Normal"
    }

  return(
  <div className="patient__report__table">
    <div className="patient__report__col">
      <div className="patient__report__row">
        <p className="patient__report__label">Underlying Risk</p>
        <p className="patient__report__value">{underlyingRiskText}</p>
        {/* <p className="patient__report__value">{props.record.risk}</p> */}
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Pattern</p>
        <p className="patient__report__value">{props.record.spirometry}</p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Pattern Severity</p>
        <p className="patient__report__value">{props.record.severity}</p>
      </div>

      {/* <div className="patient__report__row" style={localStorage.lhi == 'false' ? {display: "none"} : {}}>
        <p className="patient__report__label">Lung Health Index</p>
        <p className="patient__report__value">
          {lhiScore}
        </p>
      </div> */}
      
      {localStorage.lhi !== "false"? (
        <div className="patient__report__row" >
          <p className="patient__report__label">Lung Health Index</p>
          <p className="patient__report__value">{lhiScore}</p>
        </div>
        ) : (
          <></>
      )}

      {localStorage.Tb == "tb" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">TB Likely</p>
            <p className="patient__report__value">{props.record.tb_likely}</p>
          </div>
          <div className="patient__report__row">
            <p className="patient__report__label">TB Risk</p>
            <p className="patient__report__value">
              {/* {props.record.tb_RiskScore} */}
              {tbText}
            </p>
          </div>
        </>
      ) : (
        <></>
      )}
      {localStorage.plan == "covid" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">Covid Likely</p>
            <p className="patient__report__value">
              {props.record.covid_likely}
            </p>
          </div>
          <div className="patient__report__row">
            <p className="patient__report__label">Covid Risk</p>
            <p className="patient__report__value">
              {/* {props.record.covid_risk_score} */}
              {covidText}
            </p>
          </div>
        </>
      ) : (
        <></>
      )}


      {localStorage.asthma == "asthma" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">Asthma Likely</p>
            <p className="patient__report__value">
              {props.record.asthma_likely}
            </p>
          </div>
          <div className="patient__report__row">
            <p className="patient__report__label">Asthma Risk</p>
            <p className="patient__report__value">
              {/* {props.record.asthma_risk_score} */}
              {asthmaText}
            </p>
          </div>
        </>
      ) : (
        <></>
      )}
      {localStorage.copd == "copd" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">COPD Likely</p>
            <p className="patient__report__value">
              {props.record.COPD_likely}
            </p>
          </div>
          <div className="patient__report__row">
            <p className="patient__report__label">COPD Risk</p>
            <p className="patient__report__value">
              {/* {props.record.COPD_risk_score} */}
              {copdText}
            </p>
          </div>
        </>
      ) : (
        <></>
      )}

      {localStorage.spirometry == "spirometry" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">FEV1/FVC</p>
            <p className="patient__report__value">
              {props.record.fev1fvc_2_value}
            </p>
          </div>
        </>
       ) : (
        <></>
      )} 
      {localStorage.spirometry == "spirometry" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">FVC</p>
            <p className="patient__report__value">
              {props.record.fvc_3_value}
            </p>
          </div>
        </>
       ) : (
        <></>
      )} 
      {localStorage.spirometry == "spirometry" ? (
        <>
          <div className="patient__report__row">
            <p className="patient__report__label">FEV1</p>
            <p className="patient__report__value">
              {props.record.fev1_3_value}
            </p>
          </div>
        </>
       ) : (
        <></>
      )} 



    </div>
  </div>
)};

const Characteristics = (props) => {
  var link = props.reportLink;
  console.log(link);
  return (
    <div className="patient__report__tableforCharacterstics">
      <div className="patient__report__col">
        <div className="patient__report__row">
          <p className="patient__report__label">Cough Duration</p>
          <p className="patient__report__value">
            {props.record.record_duration} sec
          </p>
        </div>
        <div className="patient__report__row">
          <p className="patient__report__label">Cough Count</p>
          <p className="patient__report__value">
            {props.record.cough_sequence_count}
          </p>
        </div>
        <div className="patient__report__row">
          <p className="patient__report__label">Dry Cough Count</p>
          <p className="patient__report__value">
            {props.record.dry_sequence_count}
          </p>
        </div>
        <div className="patient__report__row">
          <p className="patient__report__label">Wet Cough Count</p>
          <p className="patient__report__value">
            {props.record.wet_sequence_count}
          </p>
        </div>
        {/* <div className="patient__report__row">
        <p className="patient__report__label">Cough Characteristics Report</p>
        <p className="patient__report__value">
        <a href={link ? link : null} target="/blank">{link ? <p>Open report </p> : <p>Loading...</p>}</a>
        </p>
      </div> */}
      </div>

      {/* <div className="patient__report__col">
      <div className="patient__report__row">
        <p className="patient__report__label">Average Dry Duration</p>
        <p className="patient__report__value">
          {props.record.avg_dry_duration}s
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Average Wet Duration</p>
        <p className="patient__report__value">
          {props.record.avg_wet_duration}s
        </p>
      </div> 
    </div>*/}
      {/* <div className="patient__report__col">
      <div className="patient__report__row">
        <p className="patient__report__label">
          Dry Cough
          <br />
          Frequency
        </p>
        <p className="patient__report__value">
          {parseFloat(props.record.dry_frequency).toFixed(2)} cp2m
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">
          Wet Cough
          <br />
          Frequency
        </p>
        <p className="patient__report__value">
          {parseFloat(props.record.wet_frequency).toFixed(2)} cp2m
        </p>
      </div>
    </div> */}
    </div>
  );
};

const Vitals = (props) => (
  <div className="patient__report__tableforCharacterstics">
    <div className="patient__report__col">
      <div className="patient__report__row">
        <p className="patient__report__label">Pulse Rate</p>
        <p className="patient__report__value">
          {props.record.symptoms.pulse_rate === "0"
            ? "NA"
            : props.record.symptoms.pulse_rate}{" "}
          beats/min
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Oxygen Saturation</p>
        <p className="patient__report__value">
          {props.record.symptoms.oxygen_saturation === "0"
            ? "NA"
            : props.record.symptoms.oxygen_saturation}{" "}
          %
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Temperature</p>
        <p className="patient__report__value">
          {props.record.symptoms.temperature_F === "0"
            ? "NA"
            : props.record.symptoms.temperature_F}{" "}
          F
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Respiratory Rate</p>
        <p className="patient__report__value">
          {props.record.symptoms.respiratory_rate === "0"
            ? "NA"
            : props.record.symptoms.respiratory_rate}{" "}
          breaths/min
        </p>
      </div>
      <div className="patient__report__row">
        <p className="patient__report__label">Blood Pressure</p>
        <p className="patient__report__value">
          {props.record.symptoms.blood_pressure === "0"
            ? "NA"
            : props.record.symptoms.blood_pressure}{" "}
          mmHg/mmHg
        </p>
      </div>
    </div>
  </div>
);

const Lableddata = (props) => {
  const initialState = {
    items: props.record.label,

    edit: false,
    dataExist: false,
    add: false,
    cough: {
      dry: false,
      wet: false,
      whooping: false,
    },
    pattern: {
      normal: false,
      obstructive: false,
      restrictive: false,
      mixed: false,
    },
    severity: "",
    diseaseLabel: {
      normal: false,
      allergy: false,
      asthma: false,
      bronchieatasis: false,
      copd: false,
      covid19: false,
      massLesion: false,
      pneumonia: false,
      synpneumonicEffusion: false,
      thymoma: false,
      bilateralUpperLobeFibrosis: false,
      lungCancer: false,
      ild: false,
      tb: false,
      other: false,
    },
    anatomy: {
      na: false,
      smallAirways: false,
      largeAirways: false,
      parenchyma: false,
      limitedParanchyma: false,
      extensiveParenchyma: false,
      pleura: false,
    },
    labelType: "",
    labelTypeRequired: false,
    labelTypeRequiredErrorText: false,
    comments: "",
    updateClicked: false,
    dataLoading: false,
  };
  const [state, setState] = useState(initialState);

  const [disableButton, setDisableButton] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    console.log(props);
    const label = props?.record?.label || [];
    label.sort((first, second) => {
      return moment(second.createdOn).isSameOrBefore(moment(first.createdOn))
        ? -1
        : 1;
    });
    console.log(label);

    if (!label[0]?.data) {
      setState({
        ...initialState,
        items: label,
        dataLoading: true,
        add: true,
      });
    } else {
      console.log(label[index]?.data.coughType?.includes("Dry"));
      setState({
        ...state,
        items: label,
        dataExist: true,
        dataLoading: true,
        cough: {
          dry: label[index]?.data.coughType?.split(",").includes("Dry"),
          wet: label[index]?.data.coughType?.split(",").includes("Wet"),
          whooping: label[index]?.data.coughType
            ?.split(",")
            .includes("Whooping Cough"),
        },
        pattern: {
          normal: label[index]?.data.patternType?.split(",").includes("Normal"),
          obstructive: label[index]?.data.patternType
            ?.split(",")
            .includes("Obstructive"),
          restrictive: label[index]?.data.patternType
            ?.split(",")
            .includes("Restrictive"),
          mixed: label[index]?.data.patternType?.split(",").includes("Mixed"),
        },
        severity: label[index]?.data.severityType || "",
        diseaseLabel: {
          normal: label[index]?.data.DiseaseType?.split(",").includes("Normal"),
          allergy:
            label[index]?.data.DiseaseType?.split(",").includes("Allergy"),
          asthma: label[index]?.data.DiseaseType?.split(",").includes("Asthma"),
          bronchieatasis:
            label[index]?.data.DiseaseType?.split(",").includes(
              "Bronchieatasis"
            ),
          copd: label[index]?.data.DiseaseType?.split(",").includes("COPD"),
          covid19:
            label[index]?.data.DiseaseType?.split(",").includes("COVID-19"),
          massLesion:
            label[index]?.data.DiseaseType?.split(",").includes("Mass Lesion"),
          pneumonia:
            label[index]?.data.DiseaseType?.split(",").includes("Pneumonia"),
          synpneumonicEffusion: label[index]?.data.DiseaseType?.split(
            ","
          ).includes("Synpneumonic Effusion,"),
          thymoma:
            label[index]?.data.DiseaseType?.split(",").includes("Thymoma"),
          bilateralUpperLobeFibrosis: label[index]?.data.DiseaseType?.split(
            ","
          ).includes("Bilateral UpperLobe Fibrosis"),
          lungCancer:
            label[index]?.data.DiseaseType?.split(",").includes("Lung Cancer"),
          ild: label[index]?.data.DiseaseType?.split(",").includes("ILD"),
          tb: label[index]?.data.DiseaseType?.split(",").includes("TB"),
          other: label[index]?.data.DiseaseType?.split(",").includes("Other"),
        },
        anatomy: {
          na: label[index]?.data.anatomyType?.split(",").includes("NA"),
          smallAirways: label[index]?.data.anatomyType
            ?.split(",")
            .includes("Small Airways"),
          largeAirways: label[index]?.data.anatomyType
            ?.split(",")
            .includes("Large Airways"),
          parenchyma: label[index]?.data.anatomyType
            ?.split(",")
            .includes("Parenchyma"),
          limitedParanchyma: label[index]?.data.anatomyType
            ?.split(",")
            .includes("Limited Parenchyma"),
          extensiveParenchyma: label[index]?.data.anatomyType
            ?.split(",")
            .includes("Extensive Involvement Parenchyma"),
          pleura: label[index]?.data.anatomyType?.split(",").includes("Pleura"),
        },
        labelType: label[index].data.labelType || "",
        comments: label[index]?.data.comments || "",
      });
    }
  }, [props.record, index]);
  const saveLabel = () => {
    console.log(state);
    if (!state.updateClicked) {
      // setState({
      //   ...state,
      //   labelTypeRequiredErrorText: true,
      // });

      if (state.labelType === "") {
        setState({
          ...state,
          labelTypeRequired: false,
          labelTypeRequiredErrorText: true,
        });
      } else {
        setState({ ...state, labelTypeRequired: true });
      }
      console.log(state);
      let cough = "";
      for (let key in state.cough) {
        if (state.cough[key]) {
          switch (key) {
            case "dry":
              cough += `${cough ? "," : ""}Dry`;
              break;
            case "wet":
              cough += `${cough ? "," : ""}Wet`;
              break;
            case "whooping":
              cough += `${cough ? "," : ""}Whooping Cough`;
              break;
          }
        }
      }
      let pattern = "";
      for (let key in state.pattern) {
        if (state.pattern[key]) {
          switch (key) {
            case "normal":
              pattern += `${pattern ? "," : ""}Normal`;
              break;
            case "obstructive":
              pattern += `${pattern ? "," : ""}Obstructive`;
              break;
            case "restrictive":
              pattern += `${pattern ? "," : ""}Restrictive`;
              break;
            case "mixed":
              pattern += `${pattern ? "," : ""}Mixed`;
              break;
          }
        }
      }
      let diseaseLabel = "";
      for (let key in state.diseaseLabel) {
        if (state.diseaseLabel[key]) {
          switch (key) {
            case "normal":
              diseaseLabel += `${diseaseLabel ? "," : ""}Normal`;
              break;
            case "allergy":
              diseaseLabel += `${diseaseLabel ? "," : ""}Allergy`;
              break;
            case "asthma":
              diseaseLabel += `${diseaseLabel ? "," : ""}Asthma`;
              break;
            case "bronchieatasis":
              diseaseLabel += `${diseaseLabel ? "," : ""}Bronchieatasis`;
              break;
            case "copd":
              diseaseLabel += `${diseaseLabel ? "," : ""}COPD`;
              break;
            case "covid19":
              diseaseLabel += `${diseaseLabel ? "," : ""}COVID-19`;
              break;
            case "massLesion":
              diseaseLabel += `${diseaseLabel ? "," : ""}Mass Lesion`;
              break;
            case "pneumonia":
              diseaseLabel += `${diseaseLabel ? "," : ""}Pneumonia`;
              break;
            case "synpneumonicEffusion":
              diseaseLabel += `${diseaseLabel ? "," : ""}Synpneumonic Effusion`;
              break;
            case "thymoma":
              diseaseLabel += `${diseaseLabel ? "," : ""}Thymoma`;
              break;
            case "bilateralUpperLobeFibrosis":
              diseaseLabel += `${
                diseaseLabel ? "," : ""
              }Bilateral UpperLobe Fibrosis`;
              break;
            case "lungCancer":
              diseaseLabel += `${diseaseLabel ? "," : ""}Lung Cancer`;
              break;
            case "ild":
              diseaseLabel += `${diseaseLabel ? "," : ""}ILD`;
              break;
            case "tb":
              diseaseLabel += `${diseaseLabel ? "," : ""}TB`;
              break;
            case "other":
              diseaseLabel += `${diseaseLabel ? "," : ""}Other`;
              break;
          }
        }
      }
      let anatomy = "";
      for (let key in state.anatomy) {
        if (state.anatomy[key]) {
          switch (key) {
            case "na":
              anatomy += `${anatomy ? "," : ""}NA`;
              break;
            case "smallAirways":
              anatomy += `${anatomy ? "," : ""}Small Airways`;
              break;
            case "largeAirways":
              anatomy += `${anatomy ? "," : ""}Large Airways`;
              break;
            case "parenchyma":
              anatomy += `${anatomy ? "," : ""}Parenchyma`;
              break;
            case "limitedParanchyma":
              anatomy += `${anatomy ? "," : ""}Limited Parenchyma`;
              break;
            case "extensiveParenchyma":
              anatomy += `${
                anatomy ? "," : ""
              }Extensive Involvement Parenchyma`;
              break;
            case "pleura":
              anatomy += `${anatomy ? "," : ""}Pleura`;
              break;
          }
        }
      }
      const formData = new FormData();
      if ((state.add || !state.dataExist) && state.labelTypeRequired) {
        setDisableButton(true);
        const labelData = {
          patternType: pattern,
          DiseaseType: diseaseLabel,
          coughType: cough,
          anatomyType: anatomy,
          severityType: state.severity,
          labelType: state.labelType,
          comments: state.comments,
        };
        formData.append("doctorId", props.record?.userId);
        formData.append("patient_id", props.record?.patientId || "");
        formData.append("record_id", props.record?.recordId || "");
        formData.append("fileName", props.record?.recordId || "");
        formData.append("labelData", JSON.stringify(labelData));
        axios({
          method: "POST",
          url: "/labelRecord",
          data: formData,
          headers: {
            accessToken: localStorage.accessToken,
          },
        })
          .then((response) => {
            console.log(response);

            // setTimeout(() => {
            setState({
              ...state,
              add: false,
              labelTypeRequired: false,
              updateClicked: false,
            });
            setDisableButton(false);
            props.reload();
            // }, 10);
          })
          .catch((error) => {
            console.log(error);
            setState({
              ...state,
              updateClicked: false,
            });
            setDisableButton(false);
          });
      } else if (state.edit) {
        setDisableButton(true);
        const labelData = {
          recordId: props.record?.recordId || "",
          fileName: state.items[index].fileName,
          data: {
            patternType: pattern,
            DiseaseType: diseaseLabel,
            coughType: cough,
            anatomyType: anatomy,
            severityType: state.severity,
            comments: state.comments,
            labelType: state.labelType,
          },
          createdOn: state.items[index].createdOn,
          fileType: state.items[index].fileType,
        };

        console.log(labelData);
        formData.append("patient_id", props.record?.patientId || "");
        formData.append("record_id", props.record?.recordId || "");
        formData.append("labelData", JSON.stringify(labelData));
        formData.append("fileName", props.record?.recordId || "");
        formData.append("doctorId", props.record?.userId);
        axios({
          method: "POST",
          url: "/updateRecordLabel",
          data: formData,
          headers: {
            accessToken: localStorage.accessToken,
          },
        })
          .then((response) => {
            console.log(response);
            setDisableButton(false);
            setTimeout(() => {
              setState({
                ...state,
                edit: false,
                index: 0,
                updateClicked: false,
              });
              props.reload();
            }, 10);
          })
          .catch((error) => {
            console.log(error);
            setDisableButton(false);
            setState({
              ...state,
              updateClicked: false,
            });
          });
      }
    }

    //  hack for now--  suggestion     --  maintain UpdatClicked Properly  ---
    // state.updateClicked = false
  };

  const setCoughType = (e, type) => {
    const cough = state.cough;
    cough[type] = e.target.checked;
    setState({ ...state, cough });
  };

  const setPattern = (e, type) => {
    const pattern = state.pattern;
    pattern[type] = e.target.checked;
    setState({ ...state, pattern });
  };

  const setSeverity = (e) => {
    let severity = state.severity;
    severity = e.target.value;
    setState({ ...state, severity });
  };

  const setDiseaseLabel = (e, type) => {
    const diseaseLabel = state.diseaseLabel;
    diseaseLabel[type] = e.target.checked;
    setState({ ...state, diseaseLabel });
  };

  const setAnatomy = (e, type) => {
    const anatomy = state.anatomy;
    anatomy[type] = e.target.checked;
    setState({ ...state, anatomy });
  };

  const indexOptions = () => {
    var arr = [];
    for (let i = 0; i < state.items.length; i++) {
      arr.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return arr;
  };

  // if (items?.length > 0) {
  return (
    <div
      className="patient__report__tableforCharacterstics"
      style={{ minHeight: "200px" }}
    >
      {state.dataLoading ? (
        state.edit || !state.dataExist || state.add ? (
          <React.Fragment>
            <div className="patient__report__createLabel__block">
              <p className="patient__report__createLabel__block--heading">
                Cough Type
              </p>
              <div>
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.cough.dry}
                      onChange={(e) => setCoughType(e, "dry")}
                    />
                  }
                  label="Dry"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.cough.wet}
                      onChange={(e) => setCoughType(e, "wet")}
                    />
                  }
                  label="Wet"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.cough.whooping}
                      onChange={(e) => setCoughType(e, "whooping")}
                    />
                  }
                  label="Whooping"
                />
              </div>
              <p className="patient__report__createLabel__block--heading">
                Pattern
              </p>
              <div>
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.pattern.normal}
                      onChange={(e) => setPattern(e, "normal")}
                    />
                  }
                  label="Normal"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.pattern.obstructive}
                      onChange={(e) => setPattern(e, "obstructive")}
                    />
                  }
                  label="Obstructive"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.pattern.restrictive}
                      onChange={(e) => setPattern(e, "restrictive")}
                    />
                  }
                  label="Restrictive"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.pattern.mixed}
                      onChange={(e) => setPattern(e, "mixed")}
                    />
                  }
                  label="Mixed"
                />
              </div>
              <p className="patient__report__createLabel__block--heading">
                Severity
              </p>
              <RadioGroup
                row
                aria-label="severity"
                name="severity"
                value={state.severity}
                onChange={(e) => setSeverity(e)}
              >
                <FormControlLabel
                  value="Normal"
                  control={<Radio />}
                  label="Normal"
                />
                <FormControlLabel value="Low" control={<Radio />} label="Low" />
                <FormControlLabel
                  value="Medium"
                  control={<Radio />}
                  label="Medium"
                />
                <FormControlLabel
                  value="High"
                  control={<Radio />}
                  label="High"
                />
              </RadioGroup>
            </div>
            <div className="patient__report__createLabel__block">
              <p className="patient__report__createLabel__block--heading">
                Disease Label
              </p>
              <div>
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.normal}
                      onChange={(e) => setDiseaseLabel(e, "normal")}
                    />
                  }
                  label="Normal"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.allergy}
                      onChange={(e) => setDiseaseLabel(e, "allergy")}
                    />
                  }
                  label="Allergy"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.asthma}
                      onChange={(e) => setDiseaseLabel(e, "asthma")}
                    />
                  }
                  label="Asthma"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.bronchieatasis}
                      onChange={(e) => setDiseaseLabel(e, "bronchieatasis")}
                    />
                  }
                  label="Bronchieatasis"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.copd}
                      onChange={(e) => setDiseaseLabel(e, "copd")}
                    />
                  }
                  label="COPD"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.covid19}
                      onChange={(e) => setDiseaseLabel(e, "covid19")}
                    />
                  }
                  label="COVID-19"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.massLesion}
                      onChange={(e) => setDiseaseLabel(e, "massLesion")}
                    />
                  }
                  label="Mass Lesion"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.pneumonia}
                      onChange={(e) => setDiseaseLabel(e, "pneumonia")}
                    />
                  }
                  label="Pneumonia"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.synpneumonicEffusion}
                      onChange={(e) =>
                        setDiseaseLabel(e, "synpneumonicEffusion")
                      }
                    />
                  }
                  label="Synpneumonic Effusion"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.thymoma}
                      onChange={(e) => setDiseaseLabel(e, "thymoma")}
                    />
                  }
                  label="Thymoma"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.bilateralUpperLobeFibrosis}
                      onChange={(e) =>
                        setDiseaseLabel(e, "bilateralUpperLobeFibrosis")
                      }
                    />
                  }
                  label="Bilateral Upper Lobe Fibrosis"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.lungCancer}
                      onChange={(e) => setDiseaseLabel(e, "lungCancer")}
                    />
                  }
                  label="Lung Cancer"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.ild}
                      onChange={(e) => setDiseaseLabel(e, "ild")}
                    />
                  }
                  label="ILD"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.tb}
                      onChange={(e) => setDiseaseLabel(e, "tb")}
                    />
                  }
                  label="TB"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.diseaseLabel.other}
                      onChange={(e) => setDiseaseLabel(e, "other")}
                    />
                  }
                  label="Other"
                />
              </div>
            </div>
            <div className="patient__report__createLabel__block">
              <p className="patient__report__createLabel__block--heading">
                Anatomy
              </p>
              <div>
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.na}
                      onChange={(e) => setAnatomy(e, "na")}
                    />
                  }
                  label="NA"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.smallAirways}
                      onChange={(e) => setAnatomy(e, "smallAirways")}
                    />
                  }
                  label="Small Airways"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.largeAirways}
                      onChange={(e) => setAnatomy(e, "largeAirways")}
                    />
                  }
                  label="Large Airways"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.parenchyma}
                      onChange={(e) => setAnatomy(e, "parenchyma")}
                    />
                  }
                  label="Parenchyma"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.limitedParanchyma}
                      onChange={(e) => setAnatomy(e, "limitedParanchyma")}
                    />
                  }
                  label="Limited Parenchyma"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.extensiveParenchyma}
                      onChange={(e) => setAnatomy(e, "extensiveParenchyma")}
                    />
                  }
                  label="Extensive Involvement
                  Parenchyma"
                />
                <FormControlLabel
                  control={
                    <PrimaryCheckbox
                      checked={state.anatomy.pleura}
                      onChange={(e) => setAnatomy(e, "pleura")}
                    />
                  }
                  label="Pleura"
                />
              </div>
              <p className="patient__report__createLabel__block--heading">
                Lable type
              </p>
              <div>
                <RadioGroup
                  row
                  aria-label="labelType"
                  name="labelType*"
                  value={state.labelType}
                  onChange={(e) => {
                    setState({
                      ...state,
                      labelType: e.target.value,
                      labelTypeRequired: true,
                    });
                  }}
                >
                  <FormControlLabel
                    value="Provisional"
                    control={<Radio required={true} />}
                    label="Provisional"
                  />
                  <FormControlLabel
                    value="Diagnosis"
                    control={<Radio required={true} />}
                    label="Diagnosis"
                  />
                </RadioGroup>
              </div>
              {!state.labelTypeRequired &&
                state.labelTypeRequiredErrorText &&
                state.labelType === "" && (
                  <p className="error">lable type is mandatory*</p>
                )}
              <p className="patient__report__createLabel__block--heading">
                Comments
              </p>
              <div className="d-flex justify-content-between">
                <input
                  className="patient__report__createLabel__block--comments"
                  value={state.comments}
                  onChange={(e) =>
                    setState({ ...state, comments: e.target.value })
                  }
                />
                <button
                  disabled={disableButton}
                  className="btn primary-button"
                  onClick={saveLabel}
                >
                  {state.dataExist ? "Update" : "Submit"}
                </button>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="patient__report__col patient__report__col--label">
            <div className="patient__report__row">
              <p className="patient__report__label">File name</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.fileName === "0"
                  ? "NA"
                  : state.items[index]?.fileName}
              </p>
              <div className="indexFilterStyle patients__value-filter__item">
                <p>Records</p>
                <select onChange={(e) => setIndex(e.target.value)}>
                  {indexOptions()}
                </select>
              </div>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">Disease</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.DiseaseType === "0"
                  ? "NA"
                  : state.items[index]?.data.DiseaseType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">CoughType</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.coughType === "0"
                  ? "NA"
                  : state.items[index]?.data.coughType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">Pattern</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.patternType === "0"
                  ? "NA"
                  : state.items[index]?.data.patternType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">Severity</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.severityType === "0"
                  ? "NA"
                  : state.items[index]?.data.severityType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">Anatomy</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.anatomyType === "0"
                  ? "NA"
                  : state.items[index]?.data.anatomyType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">labelType</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.labelType === ""
                  ? "NA"
                  : state.items[index]?.data.labelType}
              </p>
            </div>
            <div className="patient__report__row">
              <p className="patient__report__label">comment</p>
              <span>:</span>
              <p className="patient__report__value">
                {state.items[index]?.data.comments === ""
                  ? "NA"
                  : state.items[index]?.data.comments}
              </p>
            </div>
            <button
              className="btn primary-button"
              onClick={() => {
                setState({ ...state, edit: true });
              }}
            >
              Edit
            </button>
            <button
              className="addbtn primary-button"
              onClick={() => {
                setState({ ...initialState, add: true, dataLoading: true });
              }}
            >
              Add
            </button>
          </div>
        )
      ) : (
        ""
      )}
    </div>
  );
  // } else {
  //   return (
  //     <div className="patient__report__table">
  //       {" "}
  //       No record found for this ID{" "}
  //     </div>
  //   );
  // }
};

const ChestSounds = (props) => {
  console.log(props);
  return <div>h1</div>;
};

const Feedback = (props) => {
  const initialState = {};
  // props.reload()
  // console.log(props.record.patientId)
  // console.log(props.record.userId)
  // let formdata = new FormData();
  // formdata.append("patientId", props.record.patientId.toString());
  // formdata.append("doctorId", props.record.userId);
  // axios({
  //   method: "POST",
  //   url: `/getPatientRecords`,
  //   data: formdata,
  //   headers: {
  //     accessToken: localStorage.accessToken,
  //   },
  // })
  //   .then((response) => {
  //     console.log(true == props.record.feedback.risk_acceptance );
  //     // response.data.records[0].feedback.risk_acceptance
  //     });
  // console.log(props.patientDetails)
  const [score, setScore] = useState("");
  // console.log(props.record.feedback)
  // console.log(props.record.feedback.risk_acceptance)

  const [scoreError, setScoreError] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  var error = false;
  const [riskAcceptenceToggle, setriskAcceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.risk_acceptance === null
        ? true
        : parseInt(props.record.feedback.risk_acceptance)
      : true
  );

  const [riskAcceptenceComment, setriskAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.risk_acceptance_comments === null
        ? ""
        : props.record.feedback.risk_acceptance_comments
      : ""
  );

  const [covidriskAcceptenceToggle, setcovidriskAcceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.covid_acceptance === null
          ? true
          : parseInt(props.record.feedback.covid_tb_pred.covid_acceptance)
        : true
      : true
  );
  const [covidriskAcceptenceComment, setcovidriskAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.covid_acceptance_comments === null
          ? ""
          : props.record.feedback.covid_tb_pred.covid_acceptance_comments
        : ""
      : ""
  );
  const [tbriskAcceptenceToggle, settbriskAcceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.tb_acceptance === null
          ? true
          : parseInt(props.record.feedback.covid_tb_pred.tb_acceptance)
        : true
      : true
  );
  const [tbriskAcceptenceComment, settbriskAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.tb_acceptance_comments === null
          ? ""
          : props.record.feedback.covid_tb_pred.tb_acceptance_comments
        : ""
      : ""
  );

  const [severityAcceptenceToggle, setseverityAcceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.severity_acceptance === null
        ? true
        : parseInt(props.record.feedback.severity_acceptance)
      : true
  );
  const [severityAcceptenceComment, setseverityAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.severity_acceptance_comments === null
        ? ""
        : props.record.feedback.severity_acceptance_comments
      : ""
  );

  const [patternAcceptenceToggle, setpatternAcceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.pattern_acceptance === null
        ? true
        : parseInt(props.record.feedback.pattern_acceptance)
      : true
  );
  const [patternAcceptenceComment, setpatternAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.pattern_acceptance_comments === null
        ? ""
        : props.record.feedback.pattern_acceptance_comments
      : ""
  );

  const [
    pattern_severity_scoreAcceptenceToggle,
    setpattern_severity_scoreAcceptenceToggle,
  ] = useState(
    props.record.feedback
      ? props.record.feedback.pattern_severity_score_acceptance === null
        ? true
        : parseInt(props.record.feedback.pattern_severity_score_acceptance)
      : true
  );
  const [
    pattern_severity_scoreAcceptenceInput,
    setpattern_severity_scoreAcceptenceInput,
  ] = useState(
    props.record.feedback
      ? props.record.feedback.pattern_severity_score_acceptance_comments ===
        null
        ? ""
        : parseInt(
            props.record.feedback.pattern_severity_score_acceptance_comments
          )
      : ""
  );

  const [covid_acceptenceToggle, setcovid_acceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.covid_score_prediction === null
          ? true
          : parseInt(props.record.feedback.covid_tb_pred.covid_score_prediction)
        : true
      : true
  );
  // console.log(isNaN(props.record.feedback.covid_tb_pred.covid_score_prediction_comments));
  // console.log(isNaN(props.record.feedback.covid_tb_pred.tb_score_prediction_comments));
  const [covid_acceptenceInput, setcovid_acceptenceInput] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? parseInt(
            props.record.feedback.covid_tb_pred
              .covid_score_prediction_comments == null
              ? ""
              : props.record.feedback.covid_tb_pred
                  .covid_score_prediction_comments
          )
        : ""
      : ""
  );
  const [tb_acceptenceToggle, settb_acceptenceToggle] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? props.record.feedback.covid_tb_pred.tb_score_prediction === null
          ? true
          : parseInt(props.record.feedback.covid_tb_pred.tb_score_prediction)
        : true
      : true
  );

  const [tb_acceptenceInput, settb_acceptenceInput] = useState(
    props.record.feedback
      ? props.record.feedback.covid_tb_pred
        ? parseInt(
            props.record.feedback.covid_tb_pred.tb_score_prediction_comments ===
              null
              ? ""
              : props.record.feedback.covid_tb_pred.tb_score_prediction_comments
          )
        : ""
      : ""
  );

  // const [asthmaAcceptenceToggle, setAsthmaAcceptenceToggle] = useState(
  //   props.record.feedback
  //     ? props.record.feedback.asthma_pred === null
  //       ? true
  //       : parseInt(props.record.feedback.asthma_acceptance)
  //     : true
  // );
  // const [asthmaAcceptenceComment, setAsthmaAcceptenceComment] = useState(
  //   props.record.feedback
  //     ? props.record.feedback.asthma === null
  //       ? ""
  //       : props.record.feedback.asthma_acceptance_comments
  //     : ""
  // );
  // const [
  //   pattern_severity_scoreAcceptenceComment,
  //   setpattern_severity_scoreAcceptenceComment,
  // ] = useState("");

  const [diseaseAcceptenceToggle, setdiseaseAcceptenceToggle] = useState(false);
  const [diseaseAcceptenceComment, setdiseaseAcceptenceComment] = useState(
    props.record.feedback
      ? props.record.feedback.disease_acceptance_comments === null
        ? ""
        : props.record.feedback.disease_acceptance_comments
      : ""
  );

  const severitytoggleChange = () => {
    setseverityAcceptenceToggle(!setseverityAcceptenceToggle);
  };

  const patterntoggleChange = () => {
    setpatternAcceptenceToggle(!patternAcceptenceToggle);
  };

  const pattern_severity_scoretoggleChange = () => {
    setpattern_severity_scoreAcceptenceInput(
      !pattern_severity_scoreAcceptenceInput
    );
  };

  const diseasetoggleChange = () => {
    setdiseaseAcceptenceToggle(!diseaseAcceptenceToggle);
  };

  const onScoreChange = (value) => {
    if (value >= 1 && value <= 10) {
      setScoreError(false);
      setScore(value);
    } else {
      setScoreError(true);
      setScore("");
    }
  };

  const onSubmitFeedback = () => {
    console.log("onSubmit clicked");
    setSubmitClicked(true);
    console.log(riskAcceptenceToggle);
    console.log(riskAcceptenceComment);

    if (riskAcceptenceToggle == 0) {
      if (riskAcceptenceComment == "") {
        error = true;
      }
    }
    if (severityAcceptenceToggle == 0) {
      if (severityAcceptenceComment == "") {
        error = true;
      }
    }

    if (patternAcceptenceToggle == 0) {
      if (patternAcceptenceComment == "") {
        error = true;
      }
    }

    if (pattern_severity_scoreAcceptenceToggle == 0) {
      if (pattern_severity_scoreAcceptenceInput == "") {
        error = true;
      }
    }
    if (tbriskAcceptenceToggle == 0) {
      if (tbriskAcceptenceComment == "") {
        error = true;
      }
    }
    if (tb_acceptenceToggle == 0) {
      if (tb_acceptenceInput == "") {
        error = true;
      }
    }
    if (covidriskAcceptenceToggle == 0) {
      if (covidriskAcceptenceComment == "") {
        error = true;
      }
    }
    if (covid_acceptenceToggle == 0) {
      if (covid_acceptenceInput == "") {
        error = true;
      }
    }

    let formData = new FormData();
    console.log(props);
    formData.append("doctorId", props.record.userId);
    formData.append("recordId", props.record.recordId);
    formData.append("risk_acceptance", riskAcceptenceToggle ? 1 : 0);
    formData.append("risk_acceptance_comments", riskAcceptenceComment);
    if (localStorage.plan == "covid") {
      formData.append("covid_score_prediction", covid_acceptenceToggle ? 1 : 0);
      formData.append(
        "covid_score_prediction_comments",
        covid_acceptenceInput
      );
      formData.append("covid_acceptance", covidriskAcceptenceToggle ? 1 : 0);
      formData.append("covid_acceptance_comments", covidriskAcceptenceComment);
    }

    if (localStorage.Tb == "tb") {
      debugger
      formData.append("tb_score_prediction", tb_acceptenceToggle ? 1 : 0);
      formData.append(
        "tb_score_prediction_comments",
        // isNaN(tb_acceptenceInput) ? "" : tb_acceptenceInput
        tb_acceptenceInput
      );
      formData.append("tb_acceptance", tbriskAcceptenceToggle ? 1 : 0);
      formData.append("tb_acceptance_comments", tbriskAcceptenceComment);
      console.log(tbriskAcceptenceComment);
    }

    formData.append("severity_acceptance", severityAcceptenceToggle ? 1 : 0);
    formData.append("severity_acceptance_comments", severityAcceptenceComment);
    formData.append("pattern_acceptance", patternAcceptenceToggle ? 1 : 0);
    formData.append("pattern_acceptance_comments", patternAcceptenceComment);
    formData.append(
      "pattern_severity_score_acceptance",
      pattern_severity_scoreAcceptenceToggle ? 1 : 0
    );
    formData.append(
      "pattern_severity_score_acceptance_comments",
      pattern_severity_scoreAcceptenceInput
    );

    formData.append("disease_acceptance", diseaseAcceptenceToggle ? 1 : 0);
    formData.append("disease_acceptance_comments", diseaseAcceptenceComment);

    if (error) {
      NotificationManager.error("Please Enter Comments", "Error", 3000);
      setSubmitClicked(false);
    } else {
      axios({
        method: "POST",
        url: "/assessmentFeedback",
        data: formData,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          NotificationManager.success(
            "Your feedback has been submitted",
            "Success",
            3000
          );

          // props.reload();
          setSubmitClicked(false);
          props.reload();
          // setTimeout(() => {

          //   // eslint-disable-next-line no-unused-expressions
          //   props.reload;
          // }, 10);
          // setScore("");
          // setFeedback("");
        })
        .catch((error, errorInfo) => {
          console.log(error.response);
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                NotificationManager.error(
                  error.response.data.message,
                  "Error",
                  5000
                );
              } else {
                NotificationManager.error(
                  "Unable to submit feedback",
                  "Error",
                  3000
                );
              }
            } else {
              NotificationManager.error(
                "Unable to submit feedback",
                "Error",
                3000
              );
            }
          } else {
            NotificationManager.error(
              "Unable to submit feedback",
              "Error",
              3000
            );
          }

          setSubmitClicked(false);
        });
    }
    error = false;
  };

  return (
    <div className="feedback_custom">
      <div className="switch_custom">
        <label className="switch_label">
          <span>Do you agree with Risk prediction?</span>
          <Switch
            onChange={() => setriskAcceptenceToggle(!riskAcceptenceToggle)}
            checked={riskAcceptenceToggle}
          />
        </label>
        {!riskAcceptenceToggle && (
          <>
            <textarea
              placeholder="Please provide expected Risk (Abnormal/Normal/Other)"
              className="switch_textarea"
              value={riskAcceptenceComment}
              onChange={(e) => setriskAcceptenceComment(e.target.value)}
            ></textarea>
          </>
        )}
      </div>

      <div className="switch_custom">
        <label className="switch_label">
          <span>Do you agree with Pattern prediction?</span>
          <Switch
            onChange={() =>
              setpatternAcceptenceToggle(!patternAcceptenceToggle)
            }
            checked={patternAcceptenceToggle}
          />
        </label>
        {!patternAcceptenceToggle && (
          <>
            <textarea
              placeholder="Please provide expected Pattern (Obstructive/Restrictive/Mixed/Normal)"
              className="switch_textarea"
              value={patternAcceptenceComment}
              onChange={(e) => setpatternAcceptenceComment(e.target.value)}
            ></textarea>
          </>
        )}
      </div>

      <div className="switch_custom">
        <label className="switch_label">
          <span>Do you agree with Pattern severity prediction?</span>
          <Switch
            onChange={() =>
              setseverityAcceptenceToggle(!severityAcceptenceToggle)
            }
            checked={severityAcceptenceToggle}
          />
        </label>
        {!severityAcceptenceToggle && (
          <>
            <textarea
              placeholder="Please provide expected Pattern Severity(Low/Medium/High/Normal)"
              className="switch_textarea"
              value={severityAcceptenceComment}
              onChange={(e) => setseverityAcceptenceComment(e.target.value)}
            ></textarea>
          </>
        )}
      </div>

      <div className="switch_custom">
        <label className="switch_label">
          <span>Do you agree with Lung Health Index ?</span>
          <Switch
            onChange={() =>
              setpattern_severity_scoreAcceptenceToggle(
                !pattern_severity_scoreAcceptenceToggle
              )
            }
            checked={pattern_severity_scoreAcceptenceToggle}
          />
        </label>
        {!pattern_severity_scoreAcceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide expected Lung Health Index (Low/Medium/High/Other)"
                className="switch_textarea"
                value={pattern_severity_scoreAcceptenceInput}
                onChange={(e) =>
                  setpattern_severity_scoreAcceptenceInput(e.target.value)
                }
              ></textarea>
            </>
        )}
      </div>

      {localStorage.Tb === "tb" ? (
        <div className="switch_custom">
          <label className="switch_label">
            <span>Do you agree with TB likely detection?</span>
            <Switch
              onChange={() =>
                settbriskAcceptenceToggle(!tbriskAcceptenceToggle)
              }
              checked={tbriskAcceptenceToggle}
            />
          </label>
          {!tbriskAcceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide TB likely (yes/no)"
                className="switch_textarea"
                value={tbriskAcceptenceComment}
                onChange={(e) => 
                  {
                    console.log(e.target.value);
                    settbriskAcceptenceComment(e.target.value)}
                  }
              ></textarea>
            </>
          )}
        </div>
      ) : (
        <></>
      )}

      {localStorage.Tb === "tb" ? (
        <div className="switch_custom">
          <label className="switch_label">
            <span>Do you agree with TB Risk?</span>
            <Switch
              onChange={() => settb_acceptenceToggle(!tb_acceptenceToggle)}
              checked={tb_acceptenceToggle}
            />
          </label>
          {!tb_acceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide expected TB likey (low/Medium/High/Other)"
                className="switch_textarea"
                value={tb_acceptenceInput}
                onChange={(e) => {
                  console.log(e.target.value);
                  settb_acceptenceInput(e.target.value)}
                }
              ></textarea>
            </>
          )}
        </div>
      ) : (
        <></>
      )}
      {localStorage.plan === "covid" ? (
        <div className="switch_custom">
          <label className="switch_label">
            <span>Do you agree with Covid likely detection?</span>
            <Switch
              onChange={() =>
                setcovidriskAcceptenceToggle(!covidriskAcceptenceToggle)
              }
              checked={covidriskAcceptenceToggle}
            />
          </label>
          {!covidriskAcceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide Covid likely (yes/no)"
                className="switch_textarea"
                value={covidriskAcceptenceComment}
                onChange={(e) => setcovidriskAcceptenceComment(e.target.value)}
              ></textarea>
            </>
          )}
        </div>
      ) : (
        <></>
      )}
      {localStorage.plan === "covid" ? (
        <div className="switch_custom">
          <label className="switch_label">
            <span>Do you agree with Covid Risk ?</span>
            <Switch
              onChange={() =>
                setcovid_acceptenceToggle(!covid_acceptenceToggle)
              }
              checked={covid_acceptenceToggle}
            />
          </label>
          {!covid_acceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide expected Covid (Low/Medium/High/Other)"
                className="switch_textarea"
                value={covid_acceptenceInput}
                onChange={(e) => setcovid_acceptenceInput(e.target.value)}
              ></textarea>
            </>
          )}
        </div>
      ) : (
        <></>
      )}
      {/* {localStorage.asthma === "asthma" ? (
        <div className="switch_custom">
          <label className="switch_label">
            <span>Do you agree with Pattern prediction?</span>
            <Switch
              onChange={() =>
                setAsthmaAcceptenceToggle(!patternAcceptenceToggle)
              }
              checked={patternAcceptenceToggle}
            />
          </label>
          {!patternAcceptenceToggle && (
            <>
              <textarea
                placeholder="Please provide expected Pattern (Obstructive/Restrictive/Mixed/Normal)"
                className="switch_textarea"
                value={patternAcceptenceComment}
                onChange={(e) => setAsthmaAcceptenceComment(e.target.value)}
              ></textarea>
            </>
          )}
        </div>
      ): (
        <></>
      )} */}
      <div className="patient__report__feedback">
        {!diseaseAcceptenceToggle && (
          <>
            <textarea
              placeholder="Please provide patient condition (Upper respiratory tract infection (UTRI), Influenza-like illness (ILI), Allergy, Asthma, COPD, Pneumonia, Bronchitis, ILD, TB, Covid or any other)"
              className="switch_textarea"
              value={diseaseAcceptenceComment}
              onChange={(e) => setdiseaseAcceptenceComment(e.target.value)}
            ></textarea>
          </>
        )}
      </div>
      <div className="patient__report__feedback">
        <button onClick={() => onSubmitFeedback()} disabled={submitClicked}>
          Submit Feedback
        </button>
      </div>
    </div>
  );
};

const Remarks = (props) => {
  let feed = null;
  if (props.record?.doctorfeedback?.doctorNotes) {
    feed = props.record.doctorfeedback.doctorNotes;
  }
  const [text, setText] = useState(feed);

  const onDownload = () => {
    axios
      .get(
        `/generate_assessment_report?userId=${props.record.userId}&recordId=${props.record.recordId}&diagnostic_report=False`,
        {
          headers: { accessToken: localStorage.accessToken },
          responseType: "blob",
        }
      )
      .then((response) => {
        console.log(response);
        console.log(response.data);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${props.name}.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const onSubmit = () => {
    let formData = new FormData();
    console.log(props);
    formData.append("doctorId", props.record?.userId);
    formData.append("recordId", props.record?.recordId);
    formData.append("comments", text);

    axios({
      method: "POST",
      url: "/doctorFeedback",
      data: formData,
      headers: {
        accessToken: localStorage.accessToken,
      },
    })
      .then((response) => {
        NotificationManager.success(
          "Your feedback has been submitted",
          "Success",
          3000
        );
        props.reload();
      })
      .catch((error, errorInfo) => {
        console.log(error.response);
        if (error.response) {
          if (error.response.data) {
            if (error.response.data.message) {
              NotificationManager.error(
                error.response.data.message,
                "Error",
                5000
              );
            } else {
              NotificationManager.error(
                "Unable to submit feedback",
                "Error",
                3000
              );
            }
          } else {
            NotificationManager.error(
              "Unable to submit feedback",
              "Error",
              3000
            );
          }
        } else {
          NotificationManager.error("Unable to submit feedback", "Error", 3000);
        }
      });
  };

  return (
    <div>
      <textarea
        placeholder="Remarks/Feedback"
        className="remarks_textarea"
        value={text}
        onChange={(e) => setText(e.target.value)}
      ></textarea>

      <div className="patient__report__feedback">
        <button onClick={() => onSubmit()}>Submit</button>
        <button onClick={() => onDownload()}>Download Report</button>
      </div>
    </div>
  );
};

const Report = (props) => {
  const [tab, setTab] = useState("symptoms");
  console.log(props);

  const activeTab = {
    backgroundColor: "#fff",
    borderColor: "#fff",
    color: "#46360999",
    fontWeight: "bold",
  };
  // console.log(props.reportLink)
  if (
    localStorage.validation != "true" ||
    localStorage.longitudinal_study == "true"
  ) {
    return (
      <div className="patient__report" style={props.style ? props.style : {}}>
        <div className="patient__report__tabs">
          <button
            onClick={() => setTab("symptoms")}
            className="patient__report__tab"
            style={tab === "symptoms" ? activeTab : {}}
          >
            Symptoms
          </button>
          {localStorage.plan == "covid" ? (
            <button
              onClick={() => setTab("medicalconditions")}
              className="patient__report__tab"
              style={tab === "medicalconditions" ? activeTab : {}}
            >
              Medical Conditions
            </button>
          ) : (
            <></>
          )}
          <button
            onClick={() => setTab("indications")}
            className="patient__report__tab"
            style={tab === "indications" ? activeTab : {}}
          >
            Detections
          </button>
          <button
            onClick={() => setTab("char")}
            className="patient__report__tab"
            style={tab === "char" ? activeTab : {}}
          >
            Characteristics
          </button>
          {/* <button
          onClick={() => setTab('exposure')}
          className="patient__report__tab"
          style={tab === 'exposure' ? activeTab : {}}
        >
          Travel & Exposure
        </button> */}
          <button
            onClick={() => setTab("vital")}
            className="patient__report__tab"
            style={tab === "vital" ? activeTab : {}}
          >
            Vitals
          </button>
          <button
            onClick={() => setTab("feedback")}
            className="patient__report__tab"
            style={tab === "feedback" ? activeTab : {}}
          >
            Score & Feedback
          </button>

          {localStorage.labelling == "true" && (
            <button
              onClick={() => setTab("lable")}
              className="patient__report__tab"
              style={tab === "lable" ? activeTab : {}}
            >
              Label data
            </button>
          )}

          {localStorage.adminId == "admin@apollo.com" && (
            <button
              onClick={() => setTab("remarks")}
              className="patient__report__tab"
              style={tab === "remarks" ? activeTab : {}}
            >
              Remarks
            </button>
          )}
        </div>
        <div className="patient__report__body">
          {Object.keys(props.record).length > 0 &&
            (() => {
              switch (tab) {
                case "symptoms":
                  return <Symptoms record={props.record} />;

                case "medicalconditions":
                  return <MedicalConditions record={props.record} />;

                case "indications":
                  return <Indications record={props.record} />;

                case "char":
                  return (
                    <Characteristics
                      record={props.record}
                      reportLink={props.reportLink}
                    />
                  );

                case "vital":
                  return <Vitals record={props.record} />;

                case "feedback":
                  return (
                    <Feedback record={props.record} reload={props.reload} />
                  );

                case "remarks":
                  return (
                    <Remarks
                      record={props.record}
                      name={props.name}
                      reload={props.reload}
                    />
                  );

                case "lable":
                  return (
                    <Lableddata record={props.record} reload={props.reload} />
                  );

                default:
                  break;
              }
            })()}
        </div>
        <div className="patient__report__audio">
          {props.recordLink ? <p>Cough Record </p> : <p>No record found</p>}
          {props.recordLink && (
            <audio controls>
              <source src={props.recordLink} />
            </audio>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div className="patient__report" style={props.style ? props.style : {}}>
        <div className="patient__report__tabs">
          <button
            onClick={() => setTab("symptoms")}
            className="patient__report__tab"
            style={tab === "symptoms" ? activeTab : {}}
          >
            Symptoms
          </button>
          {localStorage.plan == "covid" ? (
            <button
              onClick={() => setTab("medicalconditions")}
              className="patient__report__tab"
              style={tab === "medicalconditions" ? activeTab : {}}
            >
              Medical Conditions
            </button>
          ) : (
            <></>
          )}
          <button
            onClick={() => setTab("vital")}
            className="patient__report__tab"
            style={tab === "vital" ? activeTab : {}}
          >
            Vitals
          </button>
          {localStorage.labelling == "true" && (
            <button
              onClick={() => setTab("lable")}
              className="patient__report__tab"
              style={tab === "lable" ? activeTab : {}}
            >
              Label data
            </button>
          )}
          {/* <button
            onClick={() => setTab("chestSounds")}
            className="patient__report__tab"
            style={tab === "chestSounds" ? activeTab : {}}
          >
            Chest Sounds
          </button> */}
        </div>
        <div className="patient__report__body">
          {Object.keys(props.record).length > 0 &&
            (() => {
              switch (tab) {
                case "symptoms":
                  return <Symptoms record={props.record} />;

                case "medicalconditions":
                  return <MedicalConditions record={props.record} />;

                case "indications":
                  return <Indications record={props.record} />;

                case "char":
                  return (
                    <Characteristics
                      record={props.record}
                      reportLink={props.reportLink}
                    />
                  );

                case "vital":
                  return <Vitals record={props.record} />;

                case "feedback":
                  return (
                    <Feedback record={props.record} reload={props.reload} />
                  );

                case "lable":
                  return (
                    <Lableddata record={props.record} reload={props.reload} />
                  );
                case "chestSounds":
                  return (
                    <ChestSounds record={props.record} reload={props.reload} />
                  );
                default:
                  break;
              }
            })()}
        </div>
        <div className="patient__report__audio">
          {props.recordLink ? <p>Cough Record </p> : <p>No record found</p>}
          {props.recordLink && (
            <audio controls>
              <source src={props.recordLink} />
            </audio>
          )}
        </div>
      </div>
    );
  }
};

export default Report;
